import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { BsModalRef, BsModalService, ModalDirective } from 'ngx-bootstrap/modal';
import { GalleryModalComponent } from 'src/app/common/modals/gallery-modal/gallery-modal.component';
import { GalleryService } from 'src/app/services/gallery/gallery.service';
import { SharedService } from 'src/app/services/shared/shared.service';
import { GalleryItems } from 'src/app/helpers';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/services/auth/auth.service';
import { NgxImageCompressService } from 'ngx-image-compress';
import { ModalController } from '@ionic/angular';
import { ViewerModalComponent } from 'ngx-ionic-image-viewer';
import { environment } from 'src/environments/environment';
import { InformationService } from 'src/app/services/information/information.service';
import { editableRole } from 'src/app/helpers/enums/role-type.enum';
import { IsDeviceOnlineService } from 'src/app/services/is-online/is-online.service';

@Component({
  selector: 'app-gallery',
  templateUrl: './gallery.component.html',
  styleUrls: ['./gallery.component.scss']
})
export class GalleryComponent implements OnInit {
  @ViewChild(ModalDirective, { static: false }) upload: ModalDirective;
  public loaded: boolean = false;
  public uploading: boolean = false;
  public userData: string = null;
  public role: string = null;
  public allItems: GalleryItems[] = [];
  public file: File = null;
  public title: string = null;
  public informationObj: Object = {};
  public uploader: UntypedFormGroup = null;
  public modalRef: BsModalRef = null;
  public subscriptions: Subscription[] = [];
  public disableForm: boolean = false;
  public editableRole: string[] = [];

  constructor(
    public modal: BsModalService,
    public fb: UntypedFormBuilder,
    public sharedService: SharedService,
    public galleryService: GalleryService,
    public authService: AuthService,
    private imageCompress: NgxImageCompressService,
    private modalController: ModalController,
    public informationService: InformationService,
    private readonly _isDeviceOnline: IsDeviceOnlineService
  ) {
    this.editableRole = editableRole;
    this.uploader = this.fb.group({
      partImage: [null, Validators.required]
    });

    this.sharedService.vinInformation.subscribe((res) => {
      res ? (this.informationObj = res) : (this.informationObj = null);
    });

    this.getUserData();
  }

  ngOnInit(): void {
    // Monitoring the Gallery modal component
    let galleryMonitor = this.sharedService.gallerySubmitted.subscribe((res) => {
      this.getPlaceholder();
    });

    this.subscriptions.push(galleryMonitor);

    // START => getting report status of a vehicle from API the disable the form
    const payload = { vehicle_id: this.sharedService.getVehicleId };

    this.informationService.getVehicleStatus(payload).subscribe((res: object) => {
      const vehicleStatus = Object.values(res['data']);

      // this.disableForm = res['data']['gallery'];
      // vehicleStatus.every((status: boolean) => status === true)
    });
    // END
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription: Subscription) => {
      subscription.unsubscribe();
    });
  }

  getUserData() {
    const authSub = this.authService.user.subscribe((res) => {
      let user: any = res && res.user ? res.user : null;

      this.userData = user ? user.user_data : null;
      this.role = user && user.user_data ? user.user_data.role : 'admin';
    });

    this.subscriptions.push(authSub);
  }

  currentIndex: number = null;
  openFieldUploader() {
    this.modalRef = this.modal.show(
      GalleryModalComponent,
      Object.assign({}, { class: 'modal-lg fieldUploaderModal' })
    );
  }

  openUpload(title: string, index: number) {
    this.file = null;
    this.currentIndex = index;
    this.title = title;
    this.upload.show();
  }

  getFile(evt: Event) {
    let target: any = evt.target;
    let fileObj: File = target['files'][0];
    let reader: FileReader = new FileReader();
    let fileFormatCheck: boolean =
      fileObj.type == 'image/png' ||
      fileObj.type == 'image/jpg' ||
      fileObj.type == 'image/jpeg' ||
      fileObj.type == 'image/webp';

    if (fileFormatCheck) {
      reader.readAsDataURL(fileObj);
      reader.onload = (ev) => {
        let base64: string = ev.target.result as string;
        this.imageCompression(base64, fileObj.name);
      };
    } else return false;
  }

  imageCompression(base64: string, fileName: string) {
    this.imageCompress.compressFile(base64, -1, 60, 50).then((res) => {
      const imageBlob = this.sharedService.dataURItoBlob(res.split(',')[1]);
      this.file = new File([imageBlob], fileName, { type: 'image/jpeg' });
    });
  }

  async openViewer(imageURL: string | any) {
    const modal = await this.modalController.create({
      component: ViewerModalComponent,
      componentProps: {
        src: imageURL,
        scheme: 'dark'
      },
      cssClass: 'ion-img-viewer',
      keyboardClose: true,
      showBackdrop: true
    });

    return await modal.present();
  }

  getPlaceholder() {
    this.loaded = true;
    let getGalleryPlaceholderSub = this.galleryService.getGalleryPlaceholder().subscribe(
      (res) => {
        let success: boolean = res['success'];
        let data: Object[] = res['data']['gallerys'];
        let url: string = res['data']['url'];

        if (success) {
          this.loaded = false;
          this.allItems = data.map((item: any) => ({
            gallery_id: item.gallery_id,
            gallery_name: item.gallery_name,
            gallery_name_arabic: item.gallery_name_arabic,
            gallery_placeholder:
              this._isDeviceOnline.currentNetwork === 'online'
                ? `${url}${item.gallery_placeholder}`
                : `./../../../../../assets/images/gallery-placeholder-images/${item.gallery_id}.png`,
            isImage: false
          }));

          // this.sharedService.setGallerySubmission = this.allItems;
          this.getGalleryData(this.allItems);
        }
      },
      (error) => {}
    );

    this.subscriptions.push(getGalleryPlaceholderSub);
  }

  getGalleryData(placeholder: GalleryItems[]) {
    const vehicleId: string = this.sharedService.getVehicleId;

    this.loaded = true;
    let getGallerySub = this.galleryService.getGallery(vehicleId).subscribe(
      (res) => {
        let success: boolean = res['success'];
        let data: Object = JSON.parse(
          res['imageUrl'] === 'storage/gallery/images/'
            ? res['data']['vehicle_gallery_data']
            : res['data']['vehicle_auction_data']
        );
        let gallery: Object[] = data ? data['parts_images'] : null;

        if (success) {
          this.loaded = false;
          if (placeholder.length) {
            let url: string = `${environment.base_path}${res['imageUrl']}`;
            let filteredGalleryIndex: number = null;

            if (gallery && gallery.length) {
              gallery.forEach((galleryItem: Object, index: number) => {
                if (galleryItem['part_id']) {
                  let newGalleryItem: GalleryItems[] = [];
                  filteredGalleryIndex = placeholder.findIndex(
                    (placeholderItem: GalleryItems) =>
                      placeholderItem.gallery_id === galleryItem['part_id']
                  );

                  if (filteredGalleryIndex !== -1) {
                    this.allItems[filteredGalleryIndex].gallery_placeholder =
                      this._isDeviceOnline.currentNetwork === 'online'
                        ? `${url}${galleryItem['image']}`
                        : galleryItem['image'];
                    this.allItems[filteredGalleryIndex].isImage = true;
                  } else {
                    if (this._isDeviceOnline.currentNetwork === 'online') {
                      newGalleryItem.push({
                        gallery_id: galleryItem['part_id'],
                        gallery_name: galleryItem['part_name'],
                        gallery_name_arabic: galleryItem['part_name_arabic'] || null,
                        gallery_placeholder: `${url}${galleryItem['image']}`,
                        isImage: true
                      });
                    } else {
                      newGalleryItem.push({
                        gallery_id: galleryItem['part_id'],
                        gallery_name: galleryItem['part_name'],
                        gallery_name_arabic: galleryItem['part_name_arabic'] || null,
                        gallery_placeholder: `${galleryItem['image']}`,
                        isImage: true
                      });
                    }

                    this.allItems = this.allItems.concat(newGalleryItem);
                  }
                }
              });
            }
          }
        } else {
          this.loaded = false;
        }
      },
      (error) => {
        this.loaded = false;
      }
    );

    this.subscriptions.push(getGallerySub);
  }

  savePartImg() {
    if (this.file) {
      const formData: FormData = new FormData();
      formData.set('vehicle_id', this.sharedService.getVehicleId);
      formData.set('part_name', this.allItems[this.currentIndex].gallery_name);
      formData.set('part_id', this.allItems[this.currentIndex].gallery_id);
      formData.set('vehicle_gallery_data', this.file);

      this.uploading = true;
      this.galleryService.setGallery(formData).subscribe(
        (res) => {
          this.uploading = false;

          this.getPlaceholder();
          this.uploader.get('partImage').updateValueAndValidity();
          this.uploader.get('partImage').setValue(null);
          this.upload.hide();
        },
        (error) => {}
      );
    }
  }
}
